<template>
  <div class="contacts">
    <h1 style="color: #fff; background: var(--color)">Контакты</h1>
    <div class="contacts-item contacts_spb">
      <h3>
        Санкт-Петербург
        <span
          ><img src="../assets/img/phoneFooter.svg" alt="" />
          {{ contactInfo.spbInfo.mainPhone }}
        </span>
      </h3>
      <div class="contacts-item-main">
        <div class="contacts-item--left">
          <div class="contacts-item_main">
            <h3>{{ contactInfo.spbInfo.storage1.name }}</h3>
            <div class="contacts-item--info">
              <h5 class="address">
                <img src="../assets/img/mark.svg" alt="" />{{
                  contactInfo.spbInfo.storage1.address
                }}
              </h5>
              <h5>
                <img src="../assets/img/phoneFooter.svg" alt="" />
                {{ contactInfo.spbInfo.storage1.phone }}
              </h5>
              <h5>
                <img src="../assets/img/email.svg" alt="" />
                {{ contactInfo.spbInfo.storage1.email }}
              </h5>
              <h5>
                <img src="../assets/img/clock.svg" alt="" /> Пн.-Пт. - с 9:00 до
                18:00
              </h5>
            </div>
          </div>
          <div class="contacts-item_map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2866.2874068144697!2d30.21422397418161!3d59.953481137636686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x469636de4c97f9a7%3A0xfd27d348043d7ec!2z0YPQuy4g0JrQvtGA0LDQsdC70LXRgdGC0YDQvtC40YLQtdC70LXQuSwgMzIg0LrQvtGA0L_Rg9GBIDEsINCh0LDQvdC60YIt0J_QtdGC0LXRgNCx0YPRgNCzLCAxOTkzOTc!5e0!3m2!1sru!2sru!4v1678542024863!5m2!1sru!2sru"
              width="330"
              height="330"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
        <div class="contacts-item--right">
          <div class="contacts-item_main">
            <h3>{{ contactInfo.spbInfo.storage2.name }}</h3>
            <div class="contacts-item--info">
              <h5 class="address">
                <img src="../assets/img/mark.svg" alt="" />{{
                  contactInfo.spbInfo.storage2.address
                }}
              </h5>
              <h5>
                <img src="../assets/img/phoneFooter.svg" alt="" />
                {{ contactInfo.spbInfo.storage2.phone }}
              </h5>
              <h5>
                <img src="../assets/img/email.svg" alt="" />
                {{ contactInfo.spbInfo.storage2.email }}
              </h5>
              <h5>
                <img src="../assets/img/clock.svg" alt="" /> Пн.-Пт. - с 8:00 до
                17:00
              </h5>
            </div>
          </div>
          <div class="contacts-item_map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1394.8229306117646!2d30.37914155547114!3d59.89447919391602!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x469630264138c36b%3A0xd99d64775054acb5!2z0YPQuy4g0KHQsNC70L7QstCwLCAzNSDQsSwg0KHQsNC90LrRgi3Qn9C10YLQtdGA0LHRg9GA0LMsIDE5MjEwMg!5e0!3m2!1sru!2sru!4v1678543586329!5m2!1sru!2sru"
              width="330"
              height="330"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <div class="contacts-item contacts_msk">
      <h3>
        Москва
        <span
          ><img src="../assets/img/phoneFooter.svg" alt="" />
          {{ contactInfo.mskInfo.mainPhone }}
        </span>
      </h3>
      <div class="contacts-item-main">
        <div class="contacts-item--left">
          <div class="contacts-item_main">
            <h3>{{ contactInfo.mskInfo.storage1.name }}</h3>
            <div class="contacts-item--info">
              <h5 class="address">
                <img src="../assets/img/mark.svg" alt="" />{{
                  contactInfo.mskInfo.storage1.address
                }}
              </h5>
              <h5>
                <img src="../assets/img/phoneFooter.svg" alt="" />
                {{ contactInfo.mskInfo.storage1.phone }}
              </h5>
              <h5>
                <img src="../assets/img/email.svg" alt="" />
                {{ contactInfo.mskInfo.storage1.email }}
              </h5>
              <h5>
                <img src="../assets/img/clock.svg" alt="" /> Пн.-Пт. - с 9:00 до
                17:00
              </h5>
            </div>
          </div>
          <div class="contacts-item_map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1972.171603977192!2d37.95363398589389!3d55.94518871387348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b52cf81672bde5%3A0x94be442fbd97d061!2z0YPQuy4g0JHRgNCw0LLQsNGA0YHQutCw0Y8sIDEwMCDRgTIsINCp0ZHQu9C60L7QstC-LCDQnNC-0YHQutC-0LLRgdC60LDRjyDQvtCx0LsuLCDQoNC-0YHRgdC40Y8sIDE0MTEwNw!5e0!3m2!1sru!2suk!4v1761027556809!5m2!1sru!2suk"
              width="330"
              height="330"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

      </div>
    </div>
    <div class="contacts-item contacts_ecb">
      <h3>
        Екатеринбург
        <span
          ><img src="../assets/img/phoneFooter.svg" alt="" />
          {{ contactInfo.ekbInfo.mainPhone }}
        </span>
      </h3>
      <div class="contacts-item-main">
        <div class="contacts-item--left">
          <div class="contacts-item_main">
            <h3>{{ contactInfo.ekbInfo.storage1.name }}</h3>
            <div class="contacts-item--info">
              <h5 class="address">
                <img src="../assets/img/mark.svg" alt="" />{{
                  contactInfo.ekbInfo.storage1.address
                }}
              </h5>
              <h5>
                <img src="../assets/img/phoneFooter.svg" alt="" />
                {{ contactInfo.ekbInfo.storage1.phone }}
              </h5>
              <h5>
                <img src="../assets/img/email.svg" alt="" />
                {{ contactInfo.ekbInfo.storage1.email }}
              </h5>
              <h5>
                <img src="../assets/img/clock.svg" alt="" /> Пн.-Пт. - с 9:00 до
                18:00
              </h5>
            </div>
          </div>
          <div class="contacts-item_map">
            <iframe
              src="https://yandex.ru/map-widget/v1/?um=constructor%3Ad78a660fc8233947af4c26b98b72df6eec8c536c5e6ee24599f2fad0ae1d0485&amp;source=constructor"
              width="330"
              height="330"
              frameborder="0"
            ></iframe>
          </div>
        </div>
        <div class="contacts-item--right">
          <div class="contacts-item_main">
            <h3>{{ contactInfo.ekbInfo.storage2.name }}</h3>
            <div class="contacts-item--info">
              <h5 class="address">
                <img src="../assets/img/mark.svg" alt="" />{{
                  contactInfo.ekbInfo.storage2.address
                }}
              </h5>
              <h5>
                <img src="../assets/img/phoneFooter.svg" alt="" />
                {{ contactInfo.ekbInfo.storage2.phone }}
              </h5>
              <h5>
                <img src="../assets/img/email.svg" alt="" />
                {{ contactInfo.ekbInfo.storage2.email }}
              </h5>
              <h5>
                <img src="../assets/img/clock.svg" alt="" /> Пн.-Пт. - с 8:30 до
                17:30
              </h5>
            </div>
          </div>
          <div class="contacts-item_map">
            <iframe
              src="https://yandex.ru/map-widget/v1/-/CCUmbUdGsC"
              width="330"
              height="330"
              allowfullscreen="true"
              style="position: relative; border: 0px"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <div class="contacts-item managers">
      <h3 class="mb-4">Отдел продаж</h3>

      <h5 class="ml-3">Москва и Санкт-Петербург</h5>

      <ul class="managers-list">
        <li
          class="managers-item"
          v-for="item in sales.mskAndSpb"
          :key="item.name"
        >
          <h6>{{ item.name }}</h6>
          <h6>{{ item.phone }}</h6>
          <h6>E-mail: {{ item.email }}</h6>
          <h6 v-if="item.additional">{{ item.additional }}</h6>
        </li>
      </ul>
      <h5 class="ml-3">Екатеринбург</h5>

      <ul class="managers-list ecb">
        <li class="managers-item" v-for="item in sales.ekb" :key="item.name">
          <h6>{{ item.name }}</h6>
          <h6>{{ item.phone }}</h6>
          <h6>E-mail: {{ item.email }}</h6>
          <h6 v-if="item.additional">{{ item.additional }}</h6>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from '../api';

export default {
  name: "Contacts",
  data: () => ({
    dialog: false,
    contactInfo: {
      spbInfo: {
        storage1: {
          name: "Офис продаж",
          address:
            "199397, г. Санкт-Петербург, ул. Кораблестроителей, д. 32 кор. 1, лит. А, пом. 39Н",
          phone: "+7 (812) 327-60-60",
          email: "izoprint@izoprint.ru",
        },
        storage2: {
          name: "Склад",
          address: "199397, г. Санкт-Петербург, ул. Салова, д. 35, лит. Б",
          phone: "+7 (921) 928-33-76",
          email: "sklad@izoprint.ru",
        },
        mainPhone: "+7 (812) 327-60-60",
      },
      mskInfo: {
        storage1: {
          name: "Склад",
          address:
            "141107, Московская обл., г.Щелково, ул. Браварская д.100 стр2",
          phone: "+7 (931) 101 98 16",
          email: "msk-sklad@izoprint.ru ",
        },
        mainPhone: "+7 (931) 101 98 16",
      },
      ekbInfo: {
        storage1: {
          name: "Офис продаж",
          address:
            '620142, г. Екатеринбург, ул.Фрунзе 35 "А", (территория ОАО "СИЗ")',
          phone: "+7 (343) 219-87-20",
          email: "ekb@izoprint.ru",
        },
        storage2: {
          name: "Склад",
          address:
            "620017 г. Екатеринбург, улица Фронтовых Бригад, 13 лит. З микрорайон Эльмаш",
          phone: "+7 (343) 219-87-20",
          email: "izoprint@izoprint.ru",
        },
        mainPhone: "+7 (343) 219-87-20",
      },
    },
    sales: {
      mskAndSpb: [
        {
          name: "Журавлева Ирина Михайловна",
          phone: "+7 (931) 398-21-46",
          email: "manager1@izoprint.ru",
          additional: "",
        },
        {
          name: "Хурсина София Андреевна",
          phone: "+7 (931) 398-21-25",
          email: "manager3@izoprint.ru",
          additional: "",
        },
        {
          name: "Стемповская Ольга Олеговна",
          phone: "+7 (931) 398-21-25",
          email: "manager4@izoprint.ru",
          additional: "Менеджер по оборудованию",
        },
      ],
      ekb: [
        {
          name: "Фролова Ольга Васильевна",
          phone: "+7 (931) 101-87-55",
          email: "ekb3@izoprint.ru",
          additional: "",
        },
        {
          name: "Клюс Татьяна",
          phone: "+7 (931) 101-75-26",
          email: "ekb@izoprint.ru",
          additional: "",
        },
      ],
    },
  }),
  methods: {
    async initInfo(){
      let res = await api.getSalesInfo();
      let res1 = await api.getStoragesInfo();

      if(res){
        this.sales = res.sales;
      }
      if (res1) {
        this.contactInfo = res1.contactInfo;
      }
    }
  },
  components: {},
  mounted() {
    this.initInfo();
    if (window.location.hash) {
      document.querySelector(window.location.hash).scrollIntoView(false);
    }
  },
};
</script>
<style lang="scss">
.contacts,
.about_page {
  h1 {
    border-bottom: 2px solid rgba(0, 0, 0, 0.12);
    padding: 5px 0;
    padding-left: 5px;
    margin-bottom: 15px;
  }

  .contacts-item {
    margin-top: 50px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.12);
    padding-bottom: 60px;

    h3 {
      max-width: 606px;
      display: flex;
      justify-content: space-between;
      span {
        img {
          width: 20px;
        }
        display: flex;
        align-items: center;
        column-gap: 5px;
      }
    }
  }
  .contacts-item-main {
    display: flex;
    column-gap: 30px;
    margin-top: 40px;

    .contacts-item--left {
      display: flex;
      width: 50%;
      column-gap: 10px;
    }
    .contacts-item--right {
      display: flex;
      width: 50%;
      column-gap: 10px;
    }

    .contacts-item_main {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      h5 {
        display: flex;
        align-items: center;
        column-gap: 5px;
        margin-top: 25px;

        &:last-child {
          align-items: baseline;
        }
      }
    }
    .contacts-item_map {
      iframe {
        border-radius: 8px;
      }
    }
  }
  .about {
    margin-top: 40px;
    margin-bottom: 40px;
    .about_main {
      margin-top: 10px;
      display: flex;
      column-gap: 30px;

      .about_main-left {
        flex-basis: 50%;
        img {
          width: 60px;
          height: 60px;
        }
        h6 {
          display: flex;
          align-items: center;
          column-gap: 10px;
          font-weight: bold;
          margin-bottom: 20px;
        }
      }

      .about_main-right {
        flex-basis: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("../assets/img/window.png");
        background-repeat: no-repeat;
        background-position: bottom;

        width: 45%;

        border-radius: 4px;

        img {
          width: 60%;
          max-width: 200px;
        }
      }
    }
  }

  .about__items {
    margin: 40px 0;
    padding-top: 40px;
    border-top: 2px solid rgba(0, 0, 0, 0.12);

    &_wrapper {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      column-gap: 20px;
    }

    h4 {
      color: var(--color);
      margin-bottom: 10px;
    }
    li {
      position: relative;
      &::before {
        display: inline-block;
        content: "•";
        color: var(--color);
        width: 15px;
      }
    }
  }
  .callback {
    border-top: 2px solid rgba(0, 0, 0, 0.12);
    border-bottom: 2px solid rgba(0, 0, 0, 0.12);
    padding-top: 40px;
    padding-bottom: 40px;

    h2 {
      margin-bottom: 20px;
    }
    p {
      text-align: center;
    }

    .callback_buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 30px;

      .btn {
        margin: 0;
      }
    }
  }
  .objects {
    margin-top: 40px;

    h2 {
      margin-bottom: 20px;
    }
    .objects_cards {
      display: flex;
      flex-wrap: wrap;
      gap: 25px;

      .object_card {
        display: flex;
        align-items: center;
        justify-content: center;
        filter: grayscale(100%);
        transition: 0.5s;
        border: 1px solid #f3f3f3;
        border-radius: 4px;
        width: 30%;

        img {
          width: 60%;
        }

        &:hover {
          box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.25);
          filter: grayscale(0%);
        }
      }
    }
  }
}
.managers {
  border-bottom: 0px solid #000 !important;
}
.managers-list {
  margin-top: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.managers-item {
  width: 30%;
  margin-left: 30px;
  margin-bottom: 15px;
  padding-left: 15px;
  border-left: 2px solid var(--color);
}
@media screen and (max-width: 1400px) {
  .contacts .contacts-item-main {
    flex-wrap: wrap;
    row-gap: 40px;
    .contacts-item--left,
    .contacts-item--right {
      width: 100%;
      justify-content: space-between;

      .contacts-item_main {
        width: 50%;
      }
      .contacts-item_map {
        width: 50%;

        iframe {
          width: 100% !important;
        }
      }
    }
  }
}
@media screen and (max-width: 960px) {
  .about__items {
    &_wrapper {
      flex-wrap: wrap;

      .about__items-right {
        margin-top: 20px;
      }
    }
  }
  .about_page .callback .callback_buttons {
    flex-wrap: wrap;
    row-gap: 10px;
  }
}
@media screen and (max-width: 625px) {
  .managers-item {
    width: 100%;
  }
  .about_page .about .about_main .about_main-right {
    display: none;
  }
  .about_page .objects .objects_cards .object_card {
    width: 45%;
  }
  .contacts .contacts-item h3 {
    flex-wrap: wrap;
    row-gap: 10px;
  }
  .contacts .contacts-item-main .contacts-item--left,
  .contacts .contacts-item-main .contacts-item--right {
    flex-wrap: wrap;
    row-gap: 20px;

    .contacts-item_main,
    .contacts-item_map {
      width: 100%;
    }
  }
}
</style>
